import React from "react";
import { Grid, Header } from "semantic-ui-react";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import SectorRow from "./SectorRow";

const SectorMap = ({ title, sectorMap, onClickSymbolFunction }) => {
  const sectors = [
    "Technology",
    "Basic Materials",
    "Communication Services",
    "Consumer Cyclical",
    "Consumer Defensive",
    "Energy",
    "Financial",
    "Healthcare",
    "Industrials",
    "Real Estate",
    "Utilities",
  ];

  return (
    <div style={{ width: "100%", overflowX: "auto", minWidth: 0 }}>
      <Header>
        <h2>{title}</h2>
      </Header>

      <div style={{ marginTop: "1%", width: "100%", minWidth: 0 }}>
        <Grid stackable style={{ margin: 0, width: "100%" }}>
          {sectors.map(
            (sector) =>
              sectorMap?.[sector] && (
                <React.Fragment key={sector}>
                  <SectorRow
                    sector={sector}
                    quotesBySector={sectorMap[sector]}
                    onClick={onClickSymbolFunction}
                  />
                </React.Fragment>
              )
          )}
        </Grid>
      </div>
    </div>
  );
};

export default SectorMap;
